import { createObjectSchema, createStringSchema } from '@dreryk/react-draft';

import { referralCommonDraftSchema } from '../referral.draft';
import { icd9ProcedureSchema } from '../shared/Icd9ProcedureField/Icd9ProcedureField.draft';
import { healthcareFacilityLocationSpecialtySchema } from '../shared/HealthcareFacilitySpecialtyField/HealthcareFacilityLocationSpecialty.draft';

import { ReferralToDiagnosticExaminationFormBean } from './ReferralToDiagnosticExaminationForm/ReferralToDiagnosticExaminationForm.types';

export const referralToDiagnosticExaminationDraftSchema = createObjectSchema<ReferralToDiagnosticExaminationFormBean>({
   icd9Procedures: icd9ProcedureSchema.array(),
   objective: createStringSchema().nullable(),
   examinationsAlreadyPerformed: createStringSchema().nullable(),
})
   .merge(referralCommonDraftSchema)
   .merge(healthcareFacilityLocationSpecialtySchema)
   .strict();
